export default __webpack_public_path__ + "static/project-slide-7-4032-2268-892e51cdd140c879e4173577364f02d0.jpg";